import { Box, Card, Typography, Divider, Button, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ActionType, InsuranceType } from '../constants';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { useSelector, useDispatch } from 'react-redux';
import { resetBeneficiaryData } from '../reducer/beneficiaryReducer';
import { resetNomineeData } from '../reducer/nomineeReducer';
import { CustomButton } from '../../../MUI_custom_component';

const BenefitCard = ({ item, selectedCompanyEntity }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userData = useSelector(state => state.user?.userData);

    const handleInsuranceCardClick = (action, insuranceType) => {
        trackAnalyticsEvent('BENEFICIARY_INSURANCE_CARD_CLICK', {
            manufacturer_id: userData?.manufacturer_id || '',
            benefit_type: insuranceType || item?.value || '',
            benefit_status: item?.status?.label || '',
            benefit_amount: item?.amount || ''
        });
    };

    const handleAddBeneficiaryClick = () => {
        trackAnalyticsEvent('BENEFICIARY_ADD_BENEFICIARY_BUTTON_CLICK', {
            manufacturer_id: userData?.manufacturer_id || '',
            benefit_type: item?.value || ''
        });
        // Reset both beneficiary and nominee reducers to clear any stale data
        dispatch(resetBeneficiaryData());
        dispatch(resetNomineeData());
        navigate('/beneficiary/add-beneficiary', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };

    const handleViewDetailsClick = () => {
        handleInsuranceCardClick('VIEW', item?.value);
        navigate('/beneficiary/detail', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };

    // const handleAddNomineeClick = () => {
    //     trackAnalyticsEvent('BENEFICIARY_ADD_NOMINEE_BUTTON_CLICK', {
    //         manufacturer_id: userData?.manufacturer_id || '',
    //         benefit_type: item?.value || '',
    //         beneficiary_id: item?.beneficiary_id || ''
    //     });
    //     handleInsuranceCardClick('ADD_NOMINEE', item?.value);
    //     navigate('/beneficiary/add-nominee', { state: { insurance_type: item?.value, beneficiary_id: item?.beneficiary_id, selectedCompanyEntity: selectedCompanyEntity } });
    // };

    const handleAddBankDetailsClick = () => {
        handleInsuranceCardClick('ADD_BANK_DETAILS', item?.value);
        navigate('/beneficiary/add-bank-details', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };
    const handleAddShopDetails = () => {
        handleInsuranceCardClick('ADD_SHOP_DETAILS', item?.value);
        navigate('/beneficiary/add-shop-details', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };
    const handleViewShopDetails = () => {
        handleInsuranceCardClick('SHOP_DETAILS', item?.value);
        navigate('/beneficiary/shop-details', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };

    const handleStaffDetails = () => {
        handleInsuranceCardClick('STAFF_DETAILS', item?.value);
        navigate('/beneficiary/staff-details', { state: { insurance_type: item?.value, selectedCompanyEntity: selectedCompanyEntity } });
    };
    return (
        <Card sx={{
            boxShadow: 'none',
            p: 2, 
            borderRadius: 2,
            position: 'relative',
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                        component="img"
                        src={item?.logo_url}
                        sx={{
                            height: 'auto',
                            width: { xs: '48px', sm: '64px' } // mobile vs desktop
                        }}
                    />
                    <Box sx={{ }}>
                        <Typography variant='h2'>{item?.name}</Typography>
                        <Typography variant='body1' sx={{ color: "#666"}}>{item?.description}</Typography>
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    right:{ xs: '15px', md: '20px'},
                    top: { xs:'5px', md: '10px'}
                }}>
                    <Typography variant='labelS' sx={{ color: item?.status?.color    }}>{item?.status?.label}</Typography> 
                </Box> 
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant='labelD' sx={{ color: '#666'}}>
                        Amount 
                    </Typography>
                    <Typography variant='body1'>
                        {item?.amount || '-'}
                    </Typography>
                </Box>
                {item?.action_button?.show && item.beneficiary_id && item?.value === InsuranceType.LIFE_INSURANCE && (
                    <CustomButton
                        onClick={handleViewDetailsClick}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                )}
                {item?.action_button?.show && item.beneficiary_id && !item.nominee_id  && item?.value === InsuranceType.MEDICAL_INSURANCE &&  (
                    <CustomButton
                        onClick={handleViewDetailsClick}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                )}
                {item?.action_button?.show && !item.beneficiary_id && item?.value !== InsuranceType.GAP_BENEFIT && item?.value !== InsuranceType.STAFF_INSURANCE &&  item?.value !== InsuranceType.SHOP_INSURANCE && (
                    <CustomButton
                        onClick={handleAddBeneficiaryClick}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                    
                )}
                {/* {item?.action_button?.show && item.beneficiary_id && !item.nominee_id && item?.value !== InsuranceType.MEDICAL_INSURANCE &&  (
                    <CustomButton
                        onClick={handleAddNomineeClick}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                )} */}
                {item?.action_button?.show && item?.value === InsuranceType.GAP_BENEFIT && item?.action_button?.label === ActionType.VIEW && (
                    <CustomButton
                        onClick={handleViewDetailsClick}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                )}
                {item?.action_button?.show && item?.value === InsuranceType.GAP_BENEFIT && item?.action_button?.label === ActionType.ADD &&  (
                    <CustomButton
                        onClick={handleAddBankDetailsClick}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                )}
                {(item?.action_button?.show && item?.value === InsuranceType.SHOP_INSURANCE && item?.action_button?.label === ActionType.ADD) &&  (
                    <CustomButton
                        onClick={handleAddShopDetails}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                )}
                {(item?.action_button?.show && item?.value === InsuranceType.SHOP_INSURANCE && item?.action_button?.label === ActionType.VIEW) &&  (
                    <CustomButton
                        onClick={handleViewShopDetails}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                )}
                {(item?.action_button?.show && item?.value === InsuranceType.STAFF_INSURANCE ) &&  (
                    <CustomButton
                        onClick={handleStaffDetails}
                        variant="outlined"
                        color="primary"
                        label={item?.action_button?.label}
                    />
                )}
            </Box>
        </Card>
    );

};

export default BenefitCard;
